export default __webpack_public_path__ + "static/media/Watch-Category-List.739f0c7b.jpg";